var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo, useState } from "react";
import { BILLING_LEGACY_PRODUCT_LABEL, BILLING_PRODUCTS_PAGE_SIZE, } from "../../../constants/billing.constants";
var subtitleOf = function (product) {
    return [
        product.code,
        product.sponsorName,
        product.isLegacy ? BILLING_LEGACY_PRODUCT_LABEL : "",
    ]
        .filter(Boolean)
        .join(" · ");
};
export var useBillingProductPicker = function (props) {
    var _a = useState(""), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var filteredProducts = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        if (query === "")
            return props.products;
        return props.products.filter(function (product) {
            return "".concat(product.description, " ").concat(subtitleOf(product))
                .toLowerCase()
                .includes(query);
        });
    }, [props.products, searchValue]);
    var visibleProducts = useMemo(function () {
        var start = (page - 1) * BILLING_PRODUCTS_PAGE_SIZE;
        return filteredProducts.slice(start, start + BILLING_PRODUCTS_PAGE_SIZE);
    }, [filteredProducts, page]);
    var onSearchChange = function (value) {
        setSearchValue(value);
        setPage(1);
    };
    var isChecked = function (id) { return props.value.includes(id); };
    var onToggle = function (id) {
        var next = props.value.includes(id)
            ? props.value.filter(function (productId) { return productId !== id; })
            : __spreadArray(__spreadArray([], props.value, true), [id], false);
        props.onChange(next);
    };
    var onSelectAll = function () {
        props.onChange(props.products.map(function (product) { return product.id; }));
    };
    var onUnselectAll = function () {
        props.onChange([]);
    };
    return {
        searchValue: searchValue,
        onSearchChange: onSearchChange,
        visibleProducts: visibleProducts,
        selectedCount: props.value.length,
        totalCount: props.products.length,
        subtitleOf: subtitleOf,
        isChecked: isChecked,
        onToggle: onToggle,
        onSelectAll: onSelectAll,
        onUnselectAll: onUnselectAll,
        page: page,
        limit: BILLING_PRODUCTS_PAGE_SIZE,
        filteredTotal: filteredProducts.length,
        onChangePage: setPage,
    };
};
